// import { EarningsList } from "components/Earnings";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EarningsList } from "../../components/EarningsList";
import { FC } from "react";

export interface IEarningsListPage {}

export const EarningsListPage: FC<IEarningsListPage> = (
  props: IEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Earnings List"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Earnings", navigateTo: "/company/earnings/list" },
      ]}
      mainContents={<EarningsList />}
    />
  );
};
